<mat-action-list onsip-no-padding-list>
  @for (topic of topicPartials | async; track topic) {
  <!-- <mat-list-item [routerLink]="['/sayso_prototype/view']" [state]="{ topicTarget: 'name' }" skipLocationChange replaceUrl> -->
  <button mat-list-item [disableRipple]="true" (click)="navigateToView(topic.target)">
    <div class="button-content">
      <span>{{ topic.targetDisplay }}</span>
      <onsip-spacer></onsip-spacer>
      <button mat-icon-button color="primary" disableRipple>
        <mat-icon>arrow_forward_ios</mat-icon>
      </button>
    </div>
  </button>
  <mat-divider></mat-divider>
  }
</mat-action-list>
